import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
  Snackbar
} from '@mui/material';
import api from '../api/axios';

const STEPS = [
  { key: 'step_1', label: 'Step 1: Qualification Overview' },
  { key: 'step_2', label: 'Step 2: Learning Architecture' },
  { key: 'step_3', label: 'Step 3: Design Story Board & MVP' },
  { key: 'step_4', label: 'Step 4: Content Creation' },
  { key: 'step_5', label: 'Step 5: Assessments' },
  { key: 'step_6', label: 'Step 6: Experience Verification' },
  { key: 'step_7', label: 'Step 7: Contact Sessions' },
  { key: 'step_8', label: 'Step 8: Exam Preparation' },
  { key: 'step_9', label: 'Step 9: Mystery Student Report' },
];

const AssistantDefaultsModal = ({ open, onClose }) => {
  const [defaults, setDefaults] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setLoading(true);
      api.get('/qualifications/0/assistant/defaults/all')
        .then(res => {
          const map = {};
          res.data.forEach(d => { map[d.step] = d.system_instruction; });
          setDefaults(map);
        })
        .catch(() => setError('Failed to load defaults'))
        .finally(() => setLoading(false));
    }
  }, [open]);

  const handleChange = (step, value) => {
    setDefaults(prev => ({ ...prev, [step]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await Promise.all(
        STEPS.map(s =>
          api.post('/qualifications/0/assistant/defaults', {
            step: s.key,
            system_instruction: defaults[s.key] || ''
          })
        )
      );
      setSuccess(true);
    } catch (e) {
      setError('Failed to save defaults');
    }
    setSaving(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Default AI Assistant Instructions Per Step</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <CircularProgress />
        ) : (
          <Box>
            {STEPS.map(s => (
              <Box key={s.key} mb={3}>
                <Typography variant="subtitle1" gutterBottom>{s.label}</Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  value={defaults[s.key] || ''}
                  onChange={e => handleChange(s.key, e.target.value)}
                  placeholder={`Default system instruction for ${s.label}`}
                  variant="outlined"
                />
              </Box>
            ))}
          </Box>
        )}
        {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Close</Button>
        <Button onClick={handleSave} variant="contained" disabled={saving || loading}>
          {saving ? 'Saving...' : 'Save Defaults'}
        </Button>
      </DialogActions>
      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        message="Defaults saved!"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Dialog>
  );
};

export default AssistantDefaultsModal; 